import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CdkMenu, CdkMenuTrigger} from "@angular/cdk/menu";
import {NgIf} from "@angular/common";
import {TMenuItem, XMenuComponent} from "../x-menu/x-menu.component";

@Component({
  selector: 'app-x-dropdown-wrapper',
  standalone: true,
  imports: [
    CdkMenu,
    XMenuComponent,
    CdkMenuTrigger,
  ],
  templateUrl: './x-dropdown-wrapper.component.html',
  styleUrl: './x-dropdown-wrapper.component.less',
})
export class XDropdownWrapperComponent {
  @Input() options: TMenuItem[] = [];
  @Input() ngModel: string = '';
  @Input() disabled: boolean = false;
  @Input() withSelectIcons: boolean = true;
  @Output() ngModelChange = new EventEmitter<string>();

  public onItemSelected(item: TMenuItem) {
    this.ngModelChange.emit(item.id);
  }
}
